import React from 'react';
import PropTypes from 'prop-types';
import Double from './double';
import Data from './data';

import styles from '../styles.scss';

const SourceChange = props => {
  const { data, tenderLogId } = props;
  let order = data.data.length > 0 ? data.data[data.data.length - 1].order : 0;
  if (data.customers.length > 0) {
    [{ order }] = data.customers;
  }

  if (data.organizer.length > 0) {
    [{ order }] = data.organizer;
  }

  return (
    <div className={styles.sourceChange}>
      {data.data.map(item => (
        <React.Fragment>{item.order < order && <Data item={item} />}</React.Fragment>
      ))}
      {data.organizer.length > 0 && (
        <div className={styles.dataBlock}>
          <div className={styles.title}>Организатор</div>
          <div className={styles.list}>
            {data.organizer.map((item, index) => {
              const key = `organizerChanges${tenderLogId}_${index}`;
              return <Double item={item} key={key} />;
            })}
          </div>
        </div>
      )}
      {data.customers.length > 0 && (
        <div className={styles.dataBlock}>
          <div className={styles.title}>Заказчики</div>
          <div className={styles.list}>
            {data.customers.map((item, index) => {
              const key = `customerChanges${tenderLogId}_${index}`;
              return (
                <div className={styles.customer} key={key}>
                  <span className={styles.number}>{index + 1}.</span>
                  <Double item={item} />
                </div>
              );
            })}
          </div>
        </div>
      )}
      {data.data.map(item => (
        <React.Fragment>{item.order >= order && <Data item={item} />}</React.Fragment>
      ))}
    </div>
  );
};

SourceChange.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  tenderLogId: PropTypes.string.isRequired,
};

export default SourceChange;
